import bronze1 from "./bronze-1.png";
import bronze2 from "./bronze-2.png";
import bronze3 from "./bronze-3.png";
import diamond1 from "./diamond-1.png";
import diamond2 from "./diamond-2.png";
import diamond3 from "./diamond-3.png";
import dunsRegisteredSeal from "./duns_registered_seal.png";
import gold1 from "./gold-1.png";
import gold2 from "./gold-2.png";
import gold3 from "./gold-3.png";
import platinum4 from "./platinum-4.png";
import red1 from "./red-1.png";
import red2 from "./red-2.png";
import red3 from "./red-3.png";
import silver1 from "./silver-1.png";
import silver2 from "./silver-2.png";
import silver3 from "./silver-3.png";
export const sealImages = {
    "bronze1": bronze1,
    "bronze2": bronze2,
    "bronze3": bronze3,
    "diamond1": diamond1,
    "diamond2": diamond2,
    "diamond3": diamond3,
    "dunsRegisteredSeal": dunsRegisteredSeal,
    "gold1": gold1,
    "gold2": gold2,
    "gold3": gold3,
    "platinum4": platinum4,
    "red1": red1,
    "red2": red2,
    "red3": red3,
    "silver1": silver1,
    "silver2": silver2,
    "silver3": silver3,
};
